export const ODS_CLIENT_SCRIPT_ID = 'ods-client'
export const ROOT_ID = 'ods-client'
